
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultants/[url_slug]",
      function () {
        return require("private-next-pages/consultants/[url_slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultants/[url_slug]"])
      });
    }
  